<style lang="less">
    .down {
        position: relative;
        .room{
            border:.02rem solid #693905;
            border-radius: 5px;
            height:100%;
            padding:0 .2rem;
            color:#693905;
            font-size: .28rem;
            // text-shadow:0px 2px 2px rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: space-around;
            span{
                display: block;
                // margin: 0 .2rem .08rem 0;
            }
            span.arrow{
                width:0;
                height:0;
                border-top:10px solid #693905;
                border-left:7px solid transparent;
                border-right:7px solid transparent;
                border-bottom:10px solid transparent;
                margin-bottom:-10px;
                transform-origin: 50% 25%;
                transition: all .3s;
            }
            span.arrow.active{
                transform: rotate(180deg);
            }
            img{
                width:.34rem;
                height:auto;
                display: block;
                margin-bottom: .06rem;
            }
        }
        .list{
            height:auto;
            padding:.1rem .3rem;
            position: absolute;
            left: 0;
            top:100%;
            z-index: 11;
            border:.02rem solid #715800;
            // text-shadow:0px 2px 2px rgba(0, 0, 0, 0.5);
            border-radius:8px;
            color:#693905;
            background: #fff;
            text-align: center;
            font-size: .28rem;
            margin-top:.2rem;
            transition: all .3s;
            transform: scale(1, 0);
            transform-origin: 0% -10%;
            box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
            >div{
                height:.6rem;
                line-height:.6rem;
            }
            >img{
                width:.3rem;
                height:auto;
                display: block;
                position: absolute;
                top:-.18rem;
                right:.2rem;
                z-index: 11;
            }
        }
        .list.active{
            transform: scale(1, 1);
        }

        .room.yellow+.list{
            background:linear-gradient(0deg,rgba(232,181,0,1) 0%,rgba(255,210,47,1) 100%);
        }
        .room.green+.list{
            background:linear-gradient(0deg,rgba(125,159,15,1) 0%,rgba(178,205,31,1) 100%);
        }
    }
</style>
<template>
    <div class="down">
        <div :class="['room',type]" :style="'width:'+width+';height:'+height+';'" @click="open=!open">
            <span>{{list[active].name}}</span>
            <span :class="['arrow',open?'active':'']"></span>
            <!-- <img src="../assets/images/down.png" alt=""> -->
        </div>
        <div :class="['list',open?'active':'']" :style="'width:'+width+';'">
            <!-- <img v-if="type=='yellow'" src="../assets/images/shape1.png" alt=""> -->
            <!-- <img v-else-if="type=='green'" src="../assets/images/shape2.png" alt=""> -->
            <div v-for="(item,index) in list" :key="index" @click="choice(index)">{{item.name}}</div>
        </div>
    </div>
</template>
<script>
export default {
    props:['width','height','type','list'],
    // props:{
    //     width:{
    //         type:'String',
    //         default:'3rem',
    //         required: true,
    //     },
    //     height:{
    //         type:'String',
    //         default:'.9rem',
    //         required: true,
    //     },
    //     type:{
    //         type:'String',
    //         default:'yellow',
    //     }
    // },
    data(){
        return {
            open:false,
            active:0,
        }
    },
    methods:{
        choice(index){
            this.$emit('change',this.list[index]);
            this.open=false;
            this.active = index;
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/selectdown.vue